import { messages } from './messages';
import { PortraitImage, LandscapeImage, ImageTypes } from './layout-image';
import EComPackingSlipNoneImage from './layout-image/images/eCom-PS-none.gif';
import EComPackingSlipTwoPanelImage from './layout-image/images/eCom-PS-Panel2.gif';
import EComPackingSlipThreePanelImage from './layout-image/images/eCom-PS-Panel3.gif';

/**
 * @typedef {import('../../prop-types/intl').MessageDescriptorPropType} MessageDescriptorPropType
 */

/**
 * @typedef {object} LayoutOption
 * @property {string} id
 * @property {MessageDescriptorPropType} title
 * @property {JSX.Element} image
 * @property {MessageDescriptorPropType} [label]
 */

export const LabelFormat = {
  FourBySix: '4x6',
  FourBySixWithPackingSlip: '4x6-i',
  Letter: 'Letter',
  LetterWithPackingSlip: 'Letter-i',
  AFour: 'A4',
  AFourWithPackingSlip: 'A4-i',
  ASix: 'A6',
  ASixWithPackingSlip: 'A6-i',
  Custom: 'Custom',
  EComPSNone: 'eCom-PS-none',
  EComPSPanel2: 'eCom-PS-Panel2',
  EComPSPanel3: 'eCom-PS-Panel3',
};

export const DefaultLayoutOptions = [
  {
    tabId: LabelFormat.FourBySix,
    title: messages.fourBySixTab,
    description: messages.labelPrinterDescription,
    options: [
      {
        id: LabelFormat.FourBySix,
        title: messages.fourBySixTitle,
        image: <PortraitImage />,
        label: messages.label4x6,
      },
      {
        id: LabelFormat.FourBySixWithPackingSlip,
        title: messages.fourBySixWithPackingSlipTitle,
        image: <PortraitImage showPackingSlip />,
        label: messages.labelWithPackingSlip4x6,
      },
    ],
  },
  {
    tabId: LabelFormat.Letter,
    title: messages.eightByElevenTab,
    description: messages.traditionalPrinterDescription,
    options: [
      {
        id: LabelFormat.Letter,
        title: messages.eightByElevenTitle,
        image: <LandscapeImage />,
        label: messages.labelLetter,
      },
      {
        id: LabelFormat.LetterWithPackingSlip,
        title: messages.eightByElevenWithPackingSlipTitle,
        image: <LandscapeImage secondImageType={ImageTypes.PackingSlip} />,
        label: messages.labelWithPackingSlipLetter,
      },
    ],
  },
];
// TODO: [SPD-19601]: Combine this with previous one when feature flag is removed
export const NewLayoutOptions = [
  {
    tabId: LabelFormat.AFour,
    title: messages.aFourTab,
    description: messages.traditionalPrinterDescription,
    options: [
      {
        id: LabelFormat.AFour,
        title: messages.aFourTitle,
        image: <PortraitImage />,
      },
      {
        id: LabelFormat.AFourWithPackingSlip,
        title: messages.aFourWithPackingSlipTitle,
        image: <PortraitImage showPackingSlip />,
      },
    ],
  },
  {
    tabId: LabelFormat.ASix,
    title: messages.aSixTab,
    description: messages.labelPrinterDescription,
    options: [
      {
        id: LabelFormat.ASix,
        title: messages.aSixTitle,
        image: <LandscapeImage />,
      },
      {
        id: LabelFormat.ASixWithPackingSlip,
        title: messages.aSixWithPackingSlipTitle,
        image: <LandscapeImage secondImageType={ImageTypes.PackingSlip} />,
      },
    ],
  },
];

export const CustomLayouts = {
  tabId: LabelFormat.Custom,
  title: messages.customTab,
  options: [
    {
      id: LabelFormat.EComPSNone,
      title: messages.eCom2Blanks,
      image: EComPackingSlipNoneImage,
    },
    {
      id: LabelFormat.EComPSPanel2,
      title: messages.eComPanel2,
      image: EComPackingSlipTwoPanelImage,
    },
    {
      id: LabelFormat.EComPSPanel3,
      title: messages.eComPanel3,
      image: EComPackingSlipThreePanelImage,
    },
  ],
};
